// src/services/instanceService.ts
// import axios from "../../axiosInstance";
import axiosInstance from "../axiosInstance";
import {
  InstanceCreatePayload,
  InstanceSearchParams,
  InstanceApiResponse,
  InstancesApiResponse,
  InstanceUpdatePayload,
  InstanceDirectorUpdatePayload
} from "../../types/superAdmin/instanceTypes";



export interface CreateInstancePayloadForApi {
  instanceData: InstanceCreatePayload;
  directorData: InstanceDirectorUpdatePayload;
}

/** Body shape for UPDATE: { instanceData } */
export interface UpdateInstancePayloadForApi {
  instanceData: InstanceUpdatePayload;
}

/**
 * Create a new instance
 */
export const createInstance = async (
  payload: CreateInstancePayloadForApi
): Promise<InstanceApiResponse> => {
  const response = await axiosInstance.post<InstanceApiResponse>("/super-admin/instances", payload);
  return response.data;
};

/**
 * Get all instances (with optional filters)
 * Defaults to large limit like your fee service.
 */
export const getAllInstances = async (
  params: InstanceSearchParams = {}
): Promise<InstancesApiResponse> => {
  const response = await axiosInstance.get<InstancesApiResponse>("/super-admin/instances", {
    params: { ...params },
  });
  return response.data;
};

export const updateInstance = async (instanceId: string, payload: UpdateInstancePayloadForApi): Promise<InstanceApiResponse> => {
  const response = await  axiosInstance.put<InstanceApiResponse>(
    `/super-admin/instances/${instanceId}`,
    payload
  );
  return response.data;
};


export const deleteInstance = async (instanceId: string): Promise<InstanceApiResponse> => {
  const response = await axiosInstance.delete<InstanceApiResponse>(
    `/super-admin/instances/${instanceId}`
  );
  return response.data;
};
